import { useStore } from '@nanostores/react'
import { useShallow } from 'zustand/shallow'

import { Button } from '@/components/atoms/Button'
import { useI18n } from '@/locales/client'
import { $hasDealersAvailable } from '@/stores/Dealers'
import useDialogsStore from '@/stores/DialogsStore'

const SendToDealerButton = () => {
  const t = useI18n()
  const toggle = useDialogsStore(useShallow(state => state.toggle))
  const hasDealersAvailable = useStore($hasDealersAvailable)
  
  const handleClick = () => {
    toggle('sendToDealer')
  }

  // Hide button if dealers have been fetched and there are none
  if (hasDealersAvailable === false) {
    return null
  }

  return (
    <Button className="my-5 text-center text-base font-semibold" onClick={handleClick}>
      {t('sendToDealerButton')}
    </Button>
  )
}

export default SendToDealerButton
